import React, { useEffect } from 'react';
import { Dialog, IconButton, Typography, Box, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import popupStyles from '../../styles/kozelDarkQuiz/popup';
import { useAppDispatch, useAppSelector } from '../../stores/store';
import { fetchNextQuizCode } from '../../features/quizCode/quizCodeSlice';

interface PersonalityType {
  type: string;
  description: string;
  ritual: string;
}

interface PopupProps {
  open: boolean;
  onClose: () => void;
  personalityType?: PersonalityType | null;
}

const Popup: React.FC<PopupProps> = ({ open, onClose, personalityType }) => {
  const classes = popupStyles();
  const dispatch = useAppDispatch();
  const { code, loading, error } = useAppSelector((state) => state.quizCode);

  const defaultPersonality = {
    type: "HONEY CRUST",
    description: "Ai mereu chef de ceva nou, te arunci cu zâmbetul înainte și îți place când viața are puțină glazură pe margine.",
    ritual: "cel care face prima impresie memorabilă"
  };

  const personality = personalityType || defaultPersonality;

  useEffect(() => {
    if (open) {
      // Fetch a new code from API every time the popup opens
      dispatch(fetchNextQuizCode());
    }
  }, [open, dispatch]);

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialogPaper }}>
      <IconButton onClick={onClose} className={classes.closeButton}>
        <CloseIcon fontSize="large" />
      </IconButton>

      <Typography variant="h4" align="center" className={classes.title}>
        ȚAPĂN!
      </Typography>
      <Typography variant="h5" align="center" className={classes.subtitle}>
        EȘTI..... <span className={classes.highlight}>{personality.type}!</span>
      </Typography>

      <Typography variant="body1" align="center" className={classes.description}>
        {personality.description}
        <span className={classes.boldHighlight}> Ritualul tău: {personality.ritual}. Ai stil. Ai ritual.</span>
      </Typography>

      <Typography variant="body2" align="center" className={classes.discountText}>
        Salvează codul și introdu-l în aplicația <span style={{ textDecoration: 'underline' }}>Carrefour Act for Good</span>, la coduri promoționale, pentru a beneficia de 20% discount la produsele Kozel!
      </Typography>

      <Typography variant="body2" align="center" className={classes.description}>
        (Atenție! Poți folosi codul o singură dată și poți beneficia doar de 1 singur cod de reducere)
      </Typography>

       <Typography variant="body2" align="center" className={`${classes.description} ${classes.boldHighlight}`}>
        Vocuher-ul este valabil până la data de 24 decembrie 2025.
      </Typography>

      {/* Display discount code */}
      <Box sx={{ mt: 4, mb: 2, textAlign: 'center' }}>
        <Typography variant="h6" sx={{ color: '#D1A85E', mb: 2 }}>
          CODUL TĂU DE REDUCERE:
        </Typography>
        
        {loading && <CircularProgress sx={{ color: '#D1A85E' }} />}
        
        {error && (
          <Typography variant="body2" sx={{ color: '#ff6b6b', padding: '16px' }}>
            {error}
          </Typography>
        )}
        
        {code && !loading && (
          <Box 
            sx={{ 
              backgroundColor: '#1a1a1a',
              border: '2px solid #D1A85E',
              borderRadius: '8px',
              padding: '16px 24px',
              display: 'inline-block',
              minWidth: '200px'
            }}
          >
            <Typography 
              variant="h4" 
              sx={{ 
                color: '#D1A85E',
                fontWeight: 'bold',
                letterSpacing: '2px',
                fontFamily: 'monospace'
              }}
            >
              {code}
            </Typography>
          </Box>
        )}
        
        {code && (
          <Typography 
            variant="caption" 
            sx={{ 
              display: 'block',
              mt: 2,
              color: '#999'
            }}
          >
            Salvează acest cod! Îl vei putea folosi pentru reducerea ta.
          </Typography>
        )}
      </Box>
    </Dialog>
  );
};

export default Popup;